import { oz } from '@weft/utils';
import { PriceTierSchema } from '../../../price-tier/price-tier-schema/price-tier-schema';

export const TieredSubscriptionPricingConfigurationInputSchema = oz.object({
  tiers: oz.array(PriceTierSchema.partial()),
}).openapi('TieredSubscriptionPricingConfigurationInput');

export type TieredSubscriptionPricingConfigurationInput = oz.infer<typeof TieredSubscriptionPricingConfigurationInputSchema>;